import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Wifi = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="bowling"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.6089 17.4577C10.8407 18.2261 10.8407 19.4724 11.6089 20.2408C12.3776 21.009 13.6237 21.009 14.3923 20.2408C15.1605 19.4724 15.1605 18.2261 14.3923 17.4577C13.6237 16.6894 12.3776 16.6894 11.6089 17.4577Z" />
      <path d="M13.0003 12.7776C11.3789 12.7776 9.85358 13.4092 8.70773 14.5562C8.25758 15.0061 8.25758 15.7354 8.70773 16.1851C9.15752 16.635 9.88648 16.635 10.3366 16.1851C11.0474 15.4733 11.9936 15.0815 13.0003 15.0815C14.0069 15.0815 14.9532 15.4733 15.6639 16.1851C15.8892 16.4101 16.1847 16.5225 16.4786 16.5225C16.774 16.5225 17.068 16.4101 17.2928 16.1851C17.743 15.7354 17.743 15.0062 17.2928 14.5562C16.147 13.4092 14.6216 12.7776 13.0003 12.7776Z" />
      <path d="M13.0005 8.98462C10.3655 8.98462 7.88823 10.0109 6.02533 11.874C5.57554 12.3239 5.57554 13.0533 6.02533 13.5029C6.47544 13.9528 7.2048 13.9528 7.65418 13.5029C9.08196 12.0747 10.981 11.2883 13.0005 11.2883C15.0192 11.2883 16.9182 12.0747 18.346 13.5029C18.5709 13.7279 18.8664 13.8404 19.1603 13.8404C19.4558 13.8404 19.7501 13.7279 19.9749 13.5029C20.4247 13.0533 20.4247 12.3239 19.9749 11.874C18.112 10.0109 15.6356 8.98462 13.0005 8.98462Z" />
      <path d="M22.6634 9.18624C20.0827 6.60463 16.6512 5.18317 13.0004 5.18317C9.34954 5.18317 5.91806 6.60463 3.33734 9.18624C2.88755 9.63622 2.88755 10.3656 3.33734 10.8152C3.5626 11.0401 3.85728 11.1526 4.15197 11.1526C4.44665 11.1526 4.74215 11.0401 4.96623 10.8152C7.11187 8.66876 9.96553 7.4869 13.0004 7.4869C16.0352 7.4869 18.888 8.66876 21.0338 10.8152C21.4835 11.2651 22.2124 11.2647 22.6627 10.8156C23.1124 10.3656 23.1124 9.63622 22.6634 9.18624Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Wifi.defaultProps = {
  className: null,
};

Wifi.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Wifi;
